<template>
  <app-content>
    <app-content-body>
      <div class="inner">
        <p class="paging">
          <app-content-nav-link
              navLinkClass="btn btn_back"
              :link="btnBackToDetail"
              :text="translations.cronDetail"
          />
        </p>
        <h1>Log</h1>
      </div>
      <app-tabs full-width logs :loadTab="appTabMap[logType]" @appTabChanged="onAppTabChanged">
        <div title="Info">
          <pre v-if="!pending.cronRunLog" v-html="cronRunLog"></pre>
        </div>
        <div title="Warning">
          <pre v-if="!pending.cronRunLog" v-html="cronRunLog"></pre>
        </div>
        <div title="Error">
          <pre v-if="!pending.cronRunLog" v-html="cronRunLog"></pre>
        </div>
        <div title="Summary">
          <pre v-if="!pending.cronRunLog" v-html="cronRunLog"></pre>
        </div>
      </app-tabs>
    </app-content-body>
  </app-content>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import appTitleMixin from 'mixins/appTitleMixin'

export default {
  name: 'cron-run-log',
  mixins: [
    appTitleMixin()
  ],
  created() {
    this.fetchLogAndCron()
  },
  data() {
    return {
      appTabMap: {
        info: 0,
        warning: 1,
        error: 2,
        summary: 3
      },
      logTypeMap: {
        0: 'info',
        1: 'warning',
        2: 'error',
        3: 'summary'
      }
    }
  },
  computed: {
    ...mapState({
      cronRunLog: state => state.crons.cronRunLog,
      cron: state => state.crons.cron,
      pending: state => state.crons.pending
    }),
    translations() {
      return {
        cronDetail: this.$gettext('Detail cronu'),
        icon: this.$gettext('Ikona')
      }
    },
    currentTitle() {
      return [
        { name: this.$gettext('Crony'), link: { name: 'crons' } },
        { name: this.cron.name, link: { name: 'cron', params: { id: this.cron._id } } },
        this.logTypeTitle
      ]
    },
    logType() {
      return this.$route.params.log
    },
    logTypeTitle() {
      return `${this.logType} log`
    },
    btnBackToDetail() {
      return {
        name: 'cron',
        params: {
          id: this.cron._id
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'getCronCode',
      'getCronRunLog',
      'getCron'
    ]),
    onAppTabChanged(v) {
      this.$router.push({
        name: 'cron-run-log',
        params: {
          id: this.$route.params.id,
          log: this.logTypeMap[v]
        }
      })
    },
    async fetchLogAndCron() {
      const id = this.$route.params.idRun
      const type = this.$route.params.log
      this.getCronRunLog({ params: { id, type } })

      // getCron for currentTitle
      if (Object.keys(this.cron).length === 0) {
        this.getCron({ params: { id, type } })
      }
    }
  }
}
</script>
